module.exports = __webpack_public_path__ + "static/bnr_wide-4ca0ae91064c274eb244e4d9be47508c.png";